'use client';

import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import Sidebar from './Sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { user, loading } = useAuth();

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  // If user is not logged in, show login page without sidebar
  if (!user) {
    return <>{children}</>;
  }

  // If user is logged in, show sidebar with content
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <div className="ml-[244px] min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default AppLayout;
